export default function Gallery({ images, onClick, onDoubleClick }) {

   
    return <div className="grid-container-4-col" >
        {images.map(image => image.type && image.type.startsWith('video/') ? <video
            key={image.id}
            className="card-img-top"
            src={image.path}
            controls
            preload="metadata"
            onDoubleClick={()=>{
                if(onDoubleClick){
                    onDoubleClick(image)
                }
            }}
            onClick={()=>{
                if(onClick){
                    onClick(image)
                }
            }}
        /> : <img key={image.id} className="card-img-top" src={image.path}
            alt={image.name}
            onDoubleClick={()=>{
                if(onDoubleClick){
                    onDoubleClick(image)
                }
            }}
            onClick={()=>{
                if(onClick){
                    onClick(image)
                }
            }}
        />)}
    </div>


}
